import React from "react";
import { ArrowRightIcon, CheckCircle2Icon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  children: React.ReactNode;
  id?: string;
  note?: string;
  tone?: "light" | "dark";
  shake?: boolean;
};
export function CtaButton({
  children,
  id,
  note,
  tone = "light",
  shake = false
}: CtaButtonProps) {
  return <div className="mx-auto w-full max-w-xl text-center" data-id="element-107" data-mp="cn5dteqz4l2v">
      <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center font-display text-lg font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_10px_0_0_#0e6b31,0_18px_30px_-10px_rgba(22,163,74,0.6)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-cta-dark active:translate-y-1 active:shadow-[0_4px_0_0_#0e6b31] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-xl ${shake ? "animate-cta-shake" : ""}`} data-id="element-108" data-mp="qj944wyq89a2">
        <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-109" data-mp="35z8weqmlrxke" />
        <span data-id="element-110" data-mp="39zj3y7q1mw1d">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-111" data-mp="3a0kp550rwywt" />
      </a>
      {note && <p className={`mt-4 text-sm leading-relaxed ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-112" data-mp="3jukpktl41fz7">
          {note}
        </p>}
    </div>;
}